import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "space-y-4"
};
const _hoisted_2 = { class: "text-neutral-800 text-sm" };
const _hoisted_3 = {
    key: 0,
    class: "text-red-500 text-sm -mt-1"
};
const _hoisted_4 = {
    key: 1,
    class: "space-y-4"
};
const _hoisted_5 = { class: "flex flex-col items-center" };
const _hoisted_6 = { class: "font-semibold text-lg" };
const _hoisted_7 = { class: "text-base mb-4" };
const _hoisted_8 = { class: "text-right uppercase" };
import { ref, nextTick } from 'vue';
import UiButton from '@/components/ui/button.vue';
import UiInput from '@/components/ui/input.vue';
import UiModal from '@/components/ui/modal.vue';
import UiIcon from '@/components/ui/icon.vue';
const MAX_PASSWORD_ATTEMPTS = 3;
export default /*@__PURE__*/ _defineComponent({
    __name: 'passwordDialog',
    emits: ['passwordProcessed', 'passwordCancelled', 'statusChanged'],
    setup(__props, { expose: __expose, emit: __emit }) {
        const emit = __emit;
        const passwordModal = ref();
        const passwordInput = ref('');
        const passwordAttempts = ref(0);
        const isWrongPassword = ref(false);
        const status = ref('idle');
        // eslint-disable-next-line no-unused-vars
        const passwordCallback = ref(null);
        // Função para lidar com solicitação de senha
        const handlePasswordRequest = async ({ callback, isWrongPassword: isWrong }) => {
            if (status.value === 'processing') {
                // Evita múltiplas solicitações de senha durante o processamento
                return;
            }
            isWrongPassword.value = isWrong;
            passwordAttempts.value += isWrong ? 1 : 0;
            if (passwordAttempts.value >= MAX_PASSWORD_ATTEMPTS) {
                status.value = 'error-max-attempts';
                emit('statusChanged', status.value);
                passwordModal.value?.open();
                return;
            }
            passwordCallback.value = callback;
            status.value = 'awaiting-password';
            emit('statusChanged', status.value);
            passwordModal.value?.open();
        };
        const handleSubmit = async () => {
            if (!passwordInput.value || !passwordCallback.value)
                return;
            try {
                status.value = 'processing';
                emit('statusChanged', status.value);
                // Chama o callback com a senha fornecida
                passwordCallback.value(passwordInput.value);
                // Limpa senha e fecha diálogo
                passwordInput.value = "";
                passwordModal.value?.cancel();
                emit('passwordProcessed');
                await nextTick();
            }
            catch (error) {
                console.error('Error handling password:', error);
                status.value = 'error-max-attempts';
                emit('statusChanged', status.value);
            }
            finally {
                // Redefine o estado de processamento
                if (status.value === 'processing') {
                    status.value = 'idle';
                    emit('statusChanged', status.value);
                }
            }
        };
        const handleClose = () => {
            passwordModal.value?.cancel();
            passwordInput.value = "";
            emit('passwordCancelled');
            // Redefine o estado
            if (status.value !== 'error-max-attempts') {
                status.value = 'idle';
                emit('statusChanged', status.value);
            }
        };
        const reset = () => {
            passwordInput.value = "";
            isWrongPassword.value = false;
            passwordAttempts.value = 0;
            status.value = 'idle';
            passwordCallback.value = null;
            emit('statusChanged', status.value);
        };
        __expose({
            handlePasswordRequest,
            reset,
            status,
            close: () => passwordModal.value?.cancel()
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(UiModal, {
                ref_key: "passwordModal",
                ref: passwordModal,
                title: _ctx.$t('pdf.enterPassword'),
                "disabled-esc": "",
                "hide-close": "",
                width: "400px"
            }, {
                footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                        (status.value === 'awaiting-password')
                            ? (_openBlock(), _createBlock(UiButton, {
                                key: 0,
                                type: "danger",
                                outline: "",
                                class: "px-6 py-3 text-sm ml-2 uppercase",
                                onClick: _cache[1] || (_cache[1] = () => handleClose())
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('button.cancel')), 1)
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        (status.value === 'awaiting-password')
                            ? (_openBlock(), _createBlock(UiButton, {
                                key: 1,
                                type: "primary",
                                class: "px-6 py-3 text-sm ml-2 uppercase",
                                onClick: _cache[2] || (_cache[2] = () => handleSubmit())
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('button.confirm')), 1)
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        (status.value === 'error-max-attempts')
                            ? (_openBlock(), _createBlock(UiButton, {
                                key: 2,
                                type: "danger",
                                outline: "",
                                class: "px-6 py-3 text-sm ml-2 uppercase",
                                onClick: _cache[3] || (_cache[3] = () => handleClose())
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('button.close')), 1)
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ])
                ]),
                default: _withCtx(() => [
                    (status.value === 'awaiting-password')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('pdf.fileProtected')), 1),
                            _createVNode(UiInput, {
                                modelValue: passwordInput.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((passwordInput).value = $event)),
                                type: "password",
                                class: "w-full"
                            }, null, 8, ["modelValue"]),
                            (isWrongPassword.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('pdf.checkPassword')), 1))
                                : _createCommentVNode("", true)
                        ]))
                        : (status.value === 'error-max-attempts')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(UiIcon, {
                                        icon: "alert-triangle",
                                        size: "42",
                                        class: "text-red-500 mb-2"
                                    }),
                                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('pdf.cannotOpenFile')), 1),
                                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('pdf.somethingWentWrong')), 1)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                ]),
                _: 1
            }, 8, ["title"]));
        };
    }
});
